import {h, Fragment} from "preact"
export default function IconPlus () {
    return (
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
            <path d="M9 3.63574V15.6357M15 9.63574L3 9.63574" stroke="#0F0F0F" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>)
}